export const AddContentFavorite = 'AddFavoriteContent';
export const AddFieldToSortOrder = 'AddFieldToSortOrder';
export const AddToContentSelection = 'AddToContentSelection';
export const AvailableActionsForEntityRequest = 'AvailableActionsForEntityRequest';
export const AvailableActionsForEntityRequestSucceeded = 'AvailableActionsForEntityRequestSucceeded';
export const CallReorderItem = 'CallReorderItem';
export const CancelBackgroundJob = 'CancelBackgroundJob';
export const ChangeCollectionVisibility = 'ChangeCollectionVisibility';
export const ChangeExtractRefreshSchedule = 'ChangeExtractRefreshSchedule';
export const ChangeDataAccelerationTaskSchedule = 'ChangeDataAccelerationTaskSchedule';
export const ChangeRecommendationType = 'ChangeRecommendationType';
export const ChangeRemoteExtractRefresh = 'ChangeRemoteExtractRefresh';
export const ChangeRemoteExtractRefreshExpectedDuration = 'ChangeRemoteExtractRefreshExpectedDuration';
export const ChangeSubscriptionDataCondition = 'ChangeSubscriptionDataCondition';
export const ChangeSubscriptionsFrequency = 'ChangeSubscriptionsFrequency';
export const ChangeSubscriptionsFormat = 'ChangeSubscriptionsFormat';
export const ChangeSubscriptionsSchedule = 'ChangeSubscriptionsSchedule';
export const ChangeSubscriptionSubject = 'ChangeSubscriptionSubject';
export const ClearMixedContentFilters = 'ClearMixedContentFilters';
export const ClearFilterContent = 'ClearFilterContent';
export const ClearSpaceContentCounts = 'ClearSpaceContentCounts';
export const ContentCountsRequest = 'ContentCountsRequest';
export const ContentCountsRequestSucceeded = 'ContentCountsRequestSucceeded';
export const ContentCountsUpToDate = 'ContentCountsUpToDate';
export const ContentFavoriteAdded = 'FavoriteContentAdded';
export const ContentFavoriteRemoved = 'ContentFavoriteRemoved';
export const ContentFilterApplied = 'ContentFilterApplied';
export const ContentTypeFilterSelected = 'ContentTypeFilterSelected';
export const CreateEmptyCollection = 'CreateEmptyCollection';
export const CreateNoNameCollection = 'CreateNoNameCollection';
export const ChangeExtractDsToLive = 'ChangeExtractDsToLive';
export const ClearDraftsState = 'ClearDraftsState';
export const CreateExtractRefresh = 'CreateExtractRefresh';
export const CreateExtracts = 'CreateExtracts';
export const CreateNewContentInfoRequest = 'CreateNewContentInfoRequest';
export const CreateNewFlow = 'CreateNewFlow';
export const CreateNewProject = 'CreateNewProject';
export const CreateNewPublishedConnection = 'CreateNewPublishedConnection';
export const CreateNewSchedule = 'CreateNewSchedule';
export const CreateNewSite = 'CreateNewSite';
export const CreateNewWorkbook = 'CreateNewWorkbook';
export const CreateRemoteExtractRefresh = 'CreateRemoteExtractRefresh';
export const DataAlertAddMe = 'DataAlertAddMe';
export const DataAlertEdit = 'DataAlertEdit';
export const DataAlertRemoveMe = 'DataAlertRemoveMe';
export const DataAlertResume = 'DataAlertResume';
export const DecrementContentCount = 'DecrementContentCount';
export const DeleteContents = 'DeleteContents';
export const DeleteContentsSucceeded = 'DeleteContentsSucceeded';
export const DeleteDataAccelerationTask = 'DeleteDataAccelerationTask';
export const DeleteExtractRefresh = 'DeleteExtractRefresh';
export const DeleteFlowDraft = 'DeleteFlowDraft';
export const DeleteGroups = 'DeleteGroups';
export const DeleteRemoteExtractRefresh = 'DeleteRemoteExtractRefresh';
export const DeleteSubscriptions = 'DeleteSubscriptions';
export const DeselectAll = 'DeselectAll';
export const DisableWorkbookAcceleration = 'DisableWorkbookAcceleration';
export const DiscardDraftFailed = 'DiscardDraftFailed';
export const DiscardDraftRequested = 'DiscardDraftRequested';
export const DiscardDraftSucceeded = 'DiscardDraftSucceeded';
export const Download = 'Download';
export const DraftFetchByParentIdFailed = 'DraftFetchByParentIdFailed';
export const DraftFetchByParentIdRequested = 'DraftFetchByParentIdRequested';
export const DraftFetchByParentIdSucceeded = 'DraftFetchByParentIdSucceeded';
export const DraftsFetchInfoFailed = 'DraftsFetchInfoFailed';
export const DraftsFetchInfoRequested = 'DraftsFetchInfoRequested';
export const DraftsFetchInfoSucceeded = 'DraftsFetchInfoSucceeded';
export const DraftsInfoAvailable = 'DraftsInfoAvailable';
export const EditConnections = 'EditConnections';
export const EditFlow = 'EditFlow';
export const EditPublishedConnection = 'EditPublishedConnection';
export const EditView = 'EditView';
export const EditWorkbook = 'EditWorkbook';
export const EnableWorkbookAcceleration = 'EnableWorkbookAcceleration';
export const EncryptContent = 'EncryptContent';
export const EnterFlowSubspace = 'EnterFlowSubspace';
export const EnterSpace = 'EnterSpace';
export const ExtractContent = 'ExtractContent';
export const GetContentDetail = 'GetContentDetail';
export const GroupDatabases = 'GroupDatabases';
export const GroupRemoveUsers = 'GroupRemoveUsers';
export const HideRecommendation = 'HideRecommendation';
export const HomeAddFavoriteSucceeded = 'HomeAddFavoriteSucceeded';
export const HomeCloseWelcomeChannel = 'HomeCloseWelcomeChannel';
export const HomeFetchFavoritesSucceeded = 'HomeRequestFavoritesSucceeded';
export const HomeFetchRecentsSucceeded = 'HomeRequestRecentsSucceeded';
export const HomeFetchRecommendationsSucceeded = 'HomeRequestRecommendationsSucceeded';
export const HomeFetchPopularSucceeded = 'HomeRequestPopularSucceeded';
export const HomeFetchSharedWithMeSucceeded = 'HomeRequestSharedWithMeSucceeded';
export const HomeGetWelcomeChannelInfo = 'HomeGetWelcomeChannelInfo';
export const HomeRemoveFavoriteSucceeded = 'HomeRemoveFavoriteSucceeded';
export const HomeUpdateShowWelcomeChannel = 'HomeUpdateShowWelcomeChannel';
export const FilterContent = 'FilterContent';
export const FilterContentType = 'FilterContentType';
export const GroupAddUsers = 'GroupAddUsers';
export const IncrementContentCount = 'IncrementContentCount';
export const IncrementRouterSpaceReactKey = 'IncrementRouterSpaceReactKey';
export const LaunchRevisionHistory = 'LaunchRevisionHistory';
export const ScheduleRefreshWithBridge = 'ScheduleRefreshWithBridge';
export const MoveContents = 'MoveContents';
export const MoveContentsSucceeded = 'MoveContentsSucceeded';
export const NewFlowForDatasource = 'NewFlowForDatasource';
export const NewWorkbookForDatasource = 'NewWorkbookForDatasource';
export const OpenCancelBackgroundJobDialog = 'OpenCancelBackgroundJobDialog';
export const OpenContentDetailDialog = 'OpenContentDetailDialog';
export const OpenManageItemsInCollectionsDialog = 'OpenManageItemsInCollectionsDialog';
export const RefreshSessionInfo = 'RefreshSessionInfo';
export const RecommendationHidden = 'RecommendationHidden';
export const RecommendationUnhidden = 'RecommendationUnhidden';
export const RemoveAlert = 'RemoveAlert';
export const RemoveContentFavorite = 'RemoveFavoriteContent';
export const RemoveExternalContentAction = 'RemoveExternalContentAction';
export const RemoveFromContentSelection = 'RemoveFromContentSelection';
export const RemoveFromThisCollection = 'RemoveFromThisCollection';
export const RenameContent = 'RenameContent';
export const ReorderItem = 'ReorderItem';
export const RequestFailed = 'RequestFailed';
export const ResetContentBusyFetching = 'ResetContentBusyFetching';
export const ResumeExtractRefresh = 'ResumeExtractRefresh';
export const ResumeSubscription = 'ResumeSubscription';
export const RouterErrorShow = 'RouterErrorShow';
export const RouterErrorHide = 'RouterErrorHide';
export const RunExtractRefresh = 'RunExtractRefresh';
export const RunExtractRefreshNow = 'RunExtractRefreshNow';
export const RunFlow = 'RunFlow';
export const RunFlowTaskRunNow = 'RunFlowTaskRunNow';
export const RunFlowTaskChangeSchedule = 'RunFlowTaskChangeSchedule';
export const RunFlowTaskChangePriority = 'RunFlowTaskChangePriority';
export const RunFlowTaskResume = 'RunFlowTaskResume';
export const RunDataAccelerationTaskRunNow = 'RunDataAccelerationTaskRunNow';
export const ScheduleRunNow = 'ScheduleRunNow';
export const ScheduleEnable = 'ScheduleEnable';
export const ScheduleDisable = 'ScheduleDisable';
export const ScheduleEdit = 'ScheduleEdit';
export const SelectAll = 'SelectAll';
export const SelectionStart = 'SelectionStart';
export const SelectionStop = 'SelectionStop';
export const SelectSortOrder = 'SelectSortOrder';
export const SetAndSavePreviousFilterPanelVisibility = 'SetAndSavePreviousFilterPanelVisibility';
export const SetContentFilterNoRequestContent = 'SetContentFilterNoRequestContent';
export const SetContentPermissions = 'SetContentPermissions';
export const SetFromPreviousFilterPanelVisibilty = 'SetFromPreviousFilterPanelVisibilty';
export const SetLayoutType = 'SetLayoutType';
export const SetExtractRefreshPriority = 'SetExtractRefreshPriority';
export const SetOrder = 'SetOrder';
export const SetIgnoreNextOrderUrlChange = 'SetIgnoreNextOrderUrlChange';
export const RemoveDraftFromContentInfo = 'RemoveDraftFromContentInfo';
export const ResetIgnoreNextOrderUrlChange = 'ResetIgnoreNextOrderUrlChange';
export const SetOwner = 'SetOwner';
export const SetOwnerSucceeded = 'SetOwnerSucceeded';
export const SetPreviousUrl = 'SetPreviousUrl';
export const SetRemoteExtractRefreshProperties = 'SetRemoteExtractRefreshProperties';
export const SetRootAdminUiState = 'SetRootAdminUiState';
export const SetSpaceInfoItem = 'SetSpaceInfoItem';
export const SetTabsWorkbook = 'SetTabsWorkbook';
export const SetTags = 'SetTags';
export const SetVizPathActionType = 'SetVizPathActionType';
export const SetDataQuality = 'SetDataQuality';
export const SetDataQualityTrigger = 'SetDataQualityTrigger';
export const SetDescription = 'SetDescription';
export const SetContact = 'SetContact';
export const SetCertification = 'SetCertification';
export const SetNlpSetting = 'SetNlpSetting';
export const ServerUserDelete = 'ServerUserDelete';
export const ServerUserEditSiteMembership = 'ServerUserEditSiteMembership';
export const ServerUserForcePasswordUpdate = 'ServerUserForcePasswordUpdate';
export const ServerUserResetLoginRateLimiting = 'ServerUserResetLoginRateLimiting';
export const ShareContent = 'ShareContent';
export const ShowContentTypes = 'ShowContentTypes';
export const SiteActivate = 'SiteActivate';
export const SiteEdit = 'SiteEdit';
export const SiteDelete = 'SiteDelete';
export const SiteNamesRequest = 'SiteNamesRequest';
export const SitesNamesRequestSucceeded = 'SitesNamesRequestSucceeded';
export const SiteSuspend = 'SiteSuspend';
export const SiteUserAddUsers = 'SiteUserAddUsers';
export const SiteUserEditSiteRole = 'SiteUserEditSiteRole';
export const SiteUserRemove = 'SiteUserRemove';
export const SiteUserEditGroupMembership = 'SiteUserEditGroupMembership';
export const SiteUserSetAuthentication = 'SiteUserSetAuthentication';
export const SiteUserForcePasswordUpdate = 'SiteUserForcePasswordUpdate';
export const SiteUserResetLoginRateLimiting = 'SiteUserResetLoginRateLimiting';
export const SyncAdGroup = 'SyncAdGroup';
export const SyncAdGroups = 'SyncAdGroups';
export const SortContent = 'SortContent';
export const SpaceContentsRequest = 'SpaceContentRequest';
export const SpaceContentsRequestSucceeded = 'SpaceContentRequestSucceeded';
export const SpaceContentsRequestFailed = 'SpaceContentRequestFailed';
export const SpaceContentsMissingSliceRequest = 'SpaceContentsMissingSliceRequest';
export const SpaceContentsSliceSucceeded = 'SpaceContentsSliceSucceeded';
export const SpaceContentsUpdateOwners = 'SpaceContentsUpdateOwners';
export const StartersFetchInfoRequested = 'StartersFetchInfoRequested';
export const StartersFetchInfoSucceeded = 'StartersFetchInfoSucceeded';
export const ToggleBackgroundJobExtendedInfoDialog = 'ToggleBackgroundJobExtendedInfoDialog';
export const ToggleShowWorkbooksAsViews = 'ToggleShowWorkbooksAsViews';
export const UndoHideRecommendation = 'UndoHideRecommendation';
export const UngroupDatabases = 'UngroupDatabases';
export const UpdateAlerts = 'UpdateAlerts';
export const UpdateAlertTotal = 'UpdateAlertTotal';
export const UpdateAssetListItems = 'UpdateAssetListItems';
export const UpdateBreadcrumbs = 'UpdateBreadcrumbs';
export const UpdateBreadcrumbHref = 'UpdateBreadcrumbHref';
export const UpdateContentDetail = 'UpdateContentDetail';
export const UpdateExplorerDisplayMode = 'UpdateExplorerDisplayMode';
export const UpdateExplorerDisplayModeInternal = 'UpdateExplorerDisplayModeInternal';
export const UpdateFilterPanelVisibility = 'UpdateFilterPanelVisibility';
export const UpdateNlpSetting = 'UpdateNlpSetting';
export const UpdateNlpSettingSucceeded = 'UpdateNlpSettingSucceeded';
export const UpdateSpaceInfoCount = 'UpdateSpaceInfoCount';
export const UpdateFiltersInBothUrlAndState = 'UpdateFiltersInBothUrlAndState';
export const UpdateUserSettings = 'UpdateUserSettings';
export const UpdateGroupsMinimumSiteRole = 'UpdateGroupsMinimumSiteRole';
export const UpdateLocalGroupsLicenseUponLogin = 'UpdateLocalGroupsLicenseUponLogin';
export const WhoHasSeenThisView = 'WhoHasSeenThisView';
export const GetUserNotifications = 'GetUserNotifications';
export const GetUserNotificationsSucceeded = 'GetUserNotificationsSucceeded';
export const GetUserNotificationsFailed = 'GetUserNotificationsFailed';
export const UpdateUserNotificationsStatus = 'UpdateUserNotificationsStatus';
export const UpdateUserNotificationsStatusSucceeded = 'UpdateUserNotificationsStatusSucceeded';
export const DeleteUserNotifications = 'DeleteUserNotifications';
export const DeleteUserNotificationsSucceeded = 'DeleteUserNotificationsSucceeded';
export const UpdateUnreadUserNotifications = 'UpdateUnreadUserNotifications';
export const CheckHasUnseenUserNotifications = 'CheckHasUnseenUserNotifications';
export const CheckHasUnseenUserNotificationsSucceeded = 'CheckHasUnseenUserNotificationsSucceeded';
export const UpdateLastSeenUserNotification = 'UpdateLastSeenUserNotification';
export const UpdateLastSeenUserNotificationSucceeded = 'UpdateLastSeenUserNotificationSucceeded';
